import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TabsModule } from 'beyond-util';
import { PregledVerifikacijeComponent } from './pregled-verifikacije.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
  ],
  declarations: [PregledVerifikacijeComponent],
  entryComponents: [PregledVerifikacijeComponent],
  exports: [PregledVerifikacijeComponent],
})
export class PregledVerifikacijeModule {}



// WEBPACK FOOTER //
// ./src/app/pages/pregled-verifikacije/pregled-verifikacije.module.ts